import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Layers } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { CustomerTiersPage } from "./pages/CustomerTiersPage";

/** Search params on /customer-tiers. The active sub-tab lives in the URL so the
 *  back button returns to the tab you were last on (and the view is shareable).
 *  `account` (+ `expanded`) drive the leaderboard's account drawer — quick view
 *  when `account` is set, full account view when `expanded` is also on. */
export interface CustomerTiersSearch {
  tab?: "movement" | "peak-churn" | "leaderboard" | "retention";
  account?: number;
  expanded?: boolean;
}

function validateCustomerTiersSearch(
  raw: Record<string, unknown>,
): CustomerTiersSearch {
  const out: CustomerTiersSearch = {};
  if (
    raw.tab === "movement" ||
    raw.tab === "peak-churn" ||
    raw.tab === "leaderboard" ||
    raw.tab === "retention"
  ) {
    out.tab = raw.tab;
  }
  if (raw.account !== undefined && raw.account !== "") {
    const n = Number(raw.account);
    if (Number.isFinite(n)) out.account = n;
  }
  if (raw.expanded === true || raw.expanded === "1" || raw.expanded === "true") {
    out.expanded = true;
  }
  return out;
}

export const customerTiersModule: FeatureModule = {
  key: "customer_tiers",
  nav: {
    label: "Customer Tiers",
    icon: Layers,
    to: "/customer-tiers",
    requires: "customer_tiers.read",
    order: 35,
    group: "Revenue",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/customer-tiers",
      component: guarded("customer_tiers.read", CustomerTiersPage),
      validateSearch: validateCustomerTiersSearch,
    }),
  ] as unknown as AnyRoute[],
};
